"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeRandomBuff = void 0;
const Random_1 = require("../../utils/Random");
function removeRandomBuff(args) {
    const { targets = [], onCompleted, } = args;
    let { sequence } = args;
    sequence = sequence.pushSequence("parallel");
    targets.forEach(({ targetId, count, includeSupernatural = false, onBuffRemoved }) => {
        for (let i = 0; i < count; i++) {
            const helpfulEffects = this.getHelpfulEffects(targetId, includeSupernatural);
            if (helpfulEffects.length === 0) {
                return;
            }
            const next = (0, Random_1.randomElement)(helpfulEffects);
            this.cancelEffect(sequence, next.id);
            onBuffRemoved === null || onBuffRemoved === void 0 ? void 0 : onBuffRemoved(sequence, targetId, next.id);
        }
    });
    onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(sequence);
}
exports.removeRandomBuff = removeRandomBuff;
